import { BiteLogType, BiteLogTypeHelper } from '@biteinc/enums';
import { LogHelper } from '@biteinc/helpers';

import { buildBiteLogListFilterSchema } from './bite_log_list_filter_schema';

app.BiteLogListView = app.PaginatedListView.extend({
  initialize(opts) {
    const options = {
      fetchOnInit: false,
      canCollapse: true,
      isReadOnly: true,
      isLocalSearch: false,
      paginateToLoadSelectedItem: true,
      cellOptions: {
        clickable: true,
      },
      cellView: app.BiteLogCellView,
      useVList: true,
      hideStatusButton: false,
      showTimestampsInLocationTimezone: true,
      filterSchemaButton: true,
      filterSchema: buildBiteLogListFilterSchema(!!app.site, !!app.location),
      ...(opts || {}),
    };
    app.PaginatedListView.prototype.initialize.apply(this, [options]);
  },

  _getLogStatusFilterEnumAndNameFunction() {
    if (!this.collection.filterFieldGroupView) {
      return null;
    }

    const logType = this.collection.filterFieldGroupView.getValue()['logType'];

    if (!logType) {
      return null;
    }

    const { logStatusEnum, logStatusEnumHelper } =
      LogHelper.getLogStatusEnumAndHelperForLogType(logType);

    if (logStatusEnum === undefined || logStatusEnumHelper === undefined) {
      return null;
    }

    return { logStatusEnum, logStatusEnumHelper };
  },

  getFieldCollection(field, _subProperty, _includeAllValues, _keyModel) {
    switch (field) {
      case 'logType':
        return app.AbstractCollection.createFromTsEnum({
          tsEnum: BiteLogType,
          nameGenerator: (logType) => {
            if (logType === BiteLogType.FatalError) {
              return `Kiosk Down/Up`;
            }
            return BiteLogTypeHelper.name(logType);
          },
        });
      case 'logStatus': {
        const enumAndHelper = this._getLogStatusFilterEnumAndNameFunction();
        if (!enumAndHelper) {
          return null;
        }
        const { logStatusEnum, logStatusEnumHelper } = enumAndHelper;

        return app.AbstractCollection.createFromTsEnum({
          tsEnum: logStatusEnum,
          nameGenerator: logStatusEnumHelper.name,
        });
      }
    }
    return null;
  },

  __cellWasClicked(cellView, _eventOpt) {
    const biteLog = cellView.model;
    const detailsView = new app.BiteLogView({
      model: biteLog,
    });
    this.showDetailsView(detailsView);
  },

  __navigateToModel(log) {
    this.scrollToItemWithId(log.id, true);
  },

  _exportQuicksandRecords() {
    const scope = app.location ?? app.site ?? app.org;

    // Reliably start the download and allows us to set the file name.
    const aLink = document.createElement('a');
    aLink.download = `system-logs-${scope.id}.csv`;
    const lines = [['Time', 'Log Type', 'Log Status', 'Client', 'Order ID']];

    this.collection.models.forEach((model) => {
      lines.push(model.toCsv());
    });
    const data = lines.join('\n');
    const csvContent = 'data:text/csv;charset=utf-8,';

    aLink.href = encodeURI(csvContent + data);
    const event = new MouseEvent('click');
    aLink.dispatchEvent(event);
  },

  render() {
    app.PaginatedListView.prototype.render.apply(this, arguments);

    if (this.collection.filterFieldGroupView) {
      // When the user changes the log type, reset the log status field to have the correct options.
      this.listenTo(
        this.collection.filterFieldGroupView.fieldViewsByField['logType'],
        app.FieldView.Events.FieldDidChangeValue,
        () => {
          this.collection.filterFieldGroupView.fieldViewsByField['logStatus'].setValue(null);
          this.collection.filterFieldGroupView.fieldViewsByField['logStatus'].setupListViewFilter(
            this,
          );
        },
      );
    }

    const $downloadButton = $(
      '<button type="button" class="btn btn-sm btn-primary download">Download as CSV</button>',
    );
    this.$('.card-header .right-button-container').prepend($downloadButton);
    $downloadButton.click(() => {
      this._exportQuicksandRecords();
    });

    return this;
  },
});
